<div class="input-button-group flex">
    <bizz-theme-preview-icon-simple class="grow rounded rounded-r-none border-2 border-form-control" [isInput]="true" [theme]="theme" [isReadOnly]="readonly" layoutType="horizontal">
    </bizz-theme-preview-icon-simple>
    <div class="button-group">
        <button type="button" [disabled]="readonly" class="default">
            <bizz-icon class="h-4 w-4" iconName="palette"></bizz-icon>
        </button>
    </div>
</div>